const messages = {
  confirmDeleteAddress: "Are you sure you want to delete selected address?",
  confirmDeleteFile: "Are you sure you want to delete this file?",
  requiredErrorMessage: "Please enter",
  validErrorMessage: "Please enter valid",
  uploadFileMessage: "Please upload File(s)",
  confirmDeleteBank: "Are you sure you want to delete selected record?",
  deleteMessage: "Deleted Successfully",
  fileExtensionError: "File extension not supported",
  duplicateFileTypeError: "File Upload Type already added",
  confirmChangeClient: "Are you sure you want to change the Client Type?",
  changeClientTypeSuccessMessage: "Client type has been changed successfully",
  confirmDeleteContact: "Are you sure you want to delete selected Contact?"
};
module.exports = { messages };
